import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["amount", "warning", "reason"];
  static values = { estimate: Number };

  connect() {
    this.amountChanged();
  }

  amountChanged() {
    const cents = this.#cents();

    this.#toggle(cents !== null && cents !== this.estimateValue);
  }

  #toggle(varies) {
    this.warningTarget.classList.toggle("hidden", !varies);
    this.reasonTarget.classList.toggle("hidden", !varies);

    // A hidden required field blocks submission without ever showing the user
    // what to fix, so the two have to move together.
    this.reasonTarget.querySelector("textarea").required = varies;
  }

  #cents() {
    const raw = this.amountTarget.value.replace(/[^\d.]/g, "");
    if (raw === "") return null;

    const cents = Math.round(parseFloat(raw) * 100);
    return Number.isNaN(cents) ? null : cents;
  }
}
